<p>configurable-form-base works!</p>
